enum Unassigned {
    Unassigned = 0
}
enum Router {
    Route_Change = 1
}

enum Login {
    Username_TextChange = 20,
    Password_TextChange,
    AuthenticatorCode_TextChange,
    OnLoginSubmit,
    OnLogout,
    OpenRequestResetPasswordControl,
    CloseRequestResetPasswordControl,
    RequestResetPassword,
    RestoreSession,
    ShowPrivacyPolicy,
    ClosePrivacyPolicy,
    CheckAgreementAccept,
    AcceptAgreement,
    UpdateSignatureByteArrayAndPinFrequency,
    UpdatePinFrequency,
    RedirectToReloginPage,
    AddEmailSuccess,
    AuthenticationModuleGetAccessInfo
}

enum TabLoadEvents {
    MedicalSummaryLoaded = 50
}

enum Sidebar {
    Open = 100,
    Close,
    AutoOpenClose,
    ToggleSidebar,
    Today_Click,
    DateInput_Changed,
    DateInput_Blur,
    Calendar_SelectDate,
    DateChanged,
    SearchTextChanged,
    SearchIsInactiveChanged,
    Select_Patient,
    Select_Patient_Duplicate,
    CreatePatient,
    CreatePatient_Cancel,
    CreatePatient_Save,
    ToggleAdvancedSearch,
    SelectPreviousPatient,
    SelectNextPatient,
    SelectPatientWithEnterKey,
    SearchInPortalChecked,
    Sidebar_LoadNotice_Counts,
    SearchInRelativesChanged
}

enum SendTaskOrMessageModel {
    Show_TaskOrMessage_Popup = 150,
    Cancel_Add,
    Body_Changed,
    Clinicians_Selection_Changed,
    End_Date_Set,
    End_Time_Set,
    End_Date_Today,
    Patients_Selection_Change,
    Patients_ClearSelection,
    Priority_Changed,
    Start_Date_Set,
    Start_Time_Set,
    Start_Date_Today,
    Subject_Changed,
    Task_FolderChecked,
    Task_Type_Changed,
    Type_Changed,
    Save,
    Submit,
    CloseVacationPopup,
    SendFromVacationPopup
    // careful not to go over 175 (see SendRecallPopup below)
}

enum SendRecallPopup {
    Show_SendRecall_Popup = 180,
    ClosePopup,
    Save,
    Submit,
    Mounted,
    Show,
    ClearClick,
    CreateClick,
    PatientSelect,
    DescriptionChange,
    ClinicianSelect,
    SpecialityChange,
    DueDateSelect,
    DueDateToday,
    PriorityChange,
    NoteChange,
    DescriptionSelect,
    DescriptionClear
}

enum HandNote {
    Unassigned = 210,
    Ready,
    LoadNoteForEdit
}

enum Documents {
    Approve = 300,
    Attachments_Load,
    Checkbox_Change,
    Create_AccompanyingSubClassChange,
    Create_AuthoringDateChange,
    Create_Clinician_Selection_Change,
    Create_HRMStatusChange,
    Create_MnemonicChange,
    Create_SourceAuthorNameChange,
    Create_NoteChange,
    Create_ObservationDateChange,
    Create_OnAttachClick,
    Create_OnCancel,
    Create_OnDescriptionChange,
    Create_OnFileSelectionChange,
    Create_OnSourcesChange,
    Create_OnTodayClick,
    Create_OnUrgencyCheckChange,
    Create_Patient_Selection_Change,
    Create_Patient_ClearSelection,
    Create_SendingFacilityIdChange,
    Create_SendingFacilityReportChange,
    Create_Set_Document_Date,
    Create_ShowDetails,
    Create_SiteChange,
    Create_SubClassChange,
    Create_UploadComplete,
    Create_UploadFailPatientProfile,
    DisplaySettings_CloseColumOrderPopupClick,
    Edit_AccompanyingSubClassChange,
    Edit_AuthoringDateChange,
    Edit_BeginUpload,
    Edit_Clinician_remove,
    Edit_Clinician_Selection_Change,
    Edit_Document_ShowDetails,
    Edit_HRMStatusChange,
    Edit_MnemonicChange,
    Edit_SourceAuthorNameChange,
    Edit_Note_Change,
    Edit_ObservationDateChange,
    Edit_OnApproveClick,
    Edit_OnCancel,
    Edit_OnDescriptionChange,
    Edit_OnFileSelectionChange,
    Edit_OnSaveClick,
    Edit_OnSourcesChange,
    Edit_OnTodayClick,
    Edit_OnUrgencyCheckChange,
    Edit_Patient_Selection_Change,
    Edit_Patient_ClearSelection,
    Edit_SendingFacilityIdChange,
    Edit_SendingFacilityReportChange,
    Edit_Set_Document_Date,
    Edit_SiteChange,
    Edit_SubClassChange,
    Edit_UploadComplete,
    Edit_SaveApprovedDocument,
    Mark_All_Document_ForApproval,
    Mark_Document_ForApproval,
    Note_Dropdown_Closed,
    Note_Load,
    Note_Dropdown_Save,
    MultiFile_Window_Resize,
    Search_ChangePage,
    SearchSettings_ClinicianFilterTextChanged,
    SearchSettings_SentByFilterTextChanged,
    SearchSettings_FromDateChanged,
    SearchSettings_OnCancelClick,
    SearchSettings_OnOkClick,
    SearchSettings_OnRefreshClick,
    SearchSettings_OnResultsPerPageChange,
    SearchSettings_SearchBoxTextChanged,
    SearchSettings_ShowOptionsButtonClick,
    SearchSettings_ToDateChanged,
    Show_Create_Document,
    Show_DocumentSearch,
    Tree_All_Documents_Selected,
    Tree_ClearSelection,
    Tree_Load_Orphans,
    Tree_Load_AssignedDocuments_Extension,
    Tree_SubClass_Selection,
    Tree_Toggle_Parent,
    Tree_Load_DeactivatedAccount,
    Tree_Load_Fax_Inbox,
    Tree_Load_Fax_Trash,
    Tree_Load_Fax_Indexed,
    View_ShowEdit,
    View_ShowNewNotesControl,
    View_HideNewNotesControl,
    View_AddNewNote,
    ExpandLeftMenu,
    CollapseLeftMenu,
    DisplayDocument,
    CancelNotesDropdown,
    DisplaySettings_ShowColumOrderPopupClick,
    ReturnToSearch,
    ToggleRememberClinician,
    ToggleRememberDescription,
    PortalStatusClicked,
    PortalStatusCancel,
    PortalSendClicked,
    PortalDocumentNoteMessageChecked,
    PortalRevokedClicked,
    CloseBatchScanPopup,
    StartANewProjectClick,
    StartANewProjectCancelClick,
    StartANewProjectContinueClick,
    OpenBatchScanPopup,
    FinishBatchScan,
    closePleaseWaitPopup,
    ContinueProjectClick,
    DeleteFileClick,
    OnPageClick,
    OnEnlargePageClick,
    OnBatchScanAttachClick,
    ClearBatchProject,
    OpenWarningDeletePopup,
    CloseWarningDeletePopup,
    OnRemovePageClick,
    OnRotatePage,
    View_UnapproveClick,
    View_ConfirmUnapprove,
    View_LoadAttachedTasks,
    View_TrailClick,
    View_AttachedCommunicationClick,
    View_AttachedCommunicationClose,
    Search_TrailClick,
    Search_AttachedCommunicationClick,
    Search_AttachedCommunicationClose,
    InboundFaxes_UpdateData,
    OnCreateNewPatientClick,
    CloseCreatePatientPopup,
    Save_NewPatient,
    ToggleRememberSite,
    ToggleRememberPatient,
    RefreshBatchScanning,
    SearchSettings_UpdateDocumentClassLocalizedNames,
    Show_OnlySelectedSites,
    ResetCache
}

enum Labs {

    // LabInbox
    SearchBoxTextChanged = 800,
    OnContainerClick,
    OnRefreshClick,

    CheckLabMessageItem,
    CheckAllLabMessageItem,

    CurrentPageChange,

    Inbox_ButtonClick_FileLabs,
    Inbox_ButtonClick_HoldLabs,

    Table_InboxRowClick,

    LabInboxColumnOrderingPopup_Close,
    LabInboxColumnOrderingPopup_Open,

    SwitchTo_AllLabsInbox,
    SwitchTo_NewLabsInbox,
    SwitchTo_SuspendedLabsInbox,
    SwitchTo_ClassifiedLabsInbox,
    SwitchTo_OpenLab,

    LabInboxSearchSettings_ShowOptionsButtonClick,
    LabInboxSearchSettings_ClinicianFilterTextChanged,
    LabInboxSearchSettings_SentByTextChanged,
    LabInboxSearchSettings_OnOkClick,
    LabInboxSearchSettings_OnCancelClick,
    LabInboxSearchSettings_OnResultsPerPageChange,
    LabInboxSearchSettings_CheckboxChange,
    LabInboxSearchSettings_FromDateChanged,
    LabInboxSearchSettings_ToDateChanged,

    LabInboxSearchSettings_IamPrescriberCheckboxChange,
    LabInboxSearchSettings_IamCcCheckboxChange,

    LabInboxSearchSettings_PortalSentByCheckAllChange,
    LabInboxSearchSettings_PortalSentByCheckChange,
    LabInboxSearchSettings_PortalStatusCheckAllChange,
    LabInboxSearchSettings_PortalStatusCheckChange,

    // Actions
    SearchBoxActionInboxTextChanged,
    OnRefreshClickActionInbox,

    LabActionsInboxColumnOrderingPopup_Close,
    LabActionsInboxColumnOrderingPopup_Open,
    LabActionsInboxSearchSettings_ClinicianPrescriptorFilterTextChanged,
    LabActionsInboxSearchSettings_ClinicianActionByFilterTextChanged,
    LabActionsInboxSearchSettings_ShowOptionsButtonClick,
    LabActionsInboxSearchSettings_OnOkClick,
    LabActionsInboxSearchSettings_OnCancelClick,
    LabActionsInboxSearchSettings_OnResultsPerPageChange,
    LabActionsInboxSearchSettings_CheckboxChange,
    LabActionsInboxSearchSettings_FromDateChanged,
    LabActionsInboxSearchSettings_ToDateChanged,

    SwitchTo_LabActionTous,
    SwitchTo_LabActionNurses,
    SwitchTo_LabActionSecretaries,
    SwitchTo_LabActionCompleted,
    SwitchTo_LabManualResults,

    Inbox_ButtonClick_FileManualLabs
}

enum LabsUI {
    ToggleAdditionalInfo = 920,
    ToggleAbnormalAndCriticalInfo,
    ToggleResults,
    ShowNoteUI,
    HideNoteUI,

    NextLab,
    PreviousLab,
    HoldLab,
    FileLab,
    PutOnHold_SaveAndOpenEncounter,
    File_SaveAndOpenEncounter,
    PutOnHold_ApprouveEncounter,
    File_ApprouveEncounter,
    ToggleHoldFileCheckBox,

    ExpandLeftMenu,
    CollapseLeftMenu,

    ToggleLinkPatientPopup,
    SelectPatientForLinking,
    LinkSelectedPatient,

    OpenAttachment,

    SiteNote_SpecialityToggle,

    SiteNote_RaisonChange,
    SiteNote_LaboratoireChange,
    SiteNote_ImagerieChange,
    SiteNote_RequeteChange,
    SiteNote_UrgentRequeteChange,

    SiteNote_ConsultationChange,
    SiteNote_UrgentConsultationChange,
    SiteNote_ConsultationSpecialityChange,
    SiteNote_ConsultationDestinataireSelect,
    SiteNote_ConsultationDestinataireClear,
    SiteNote_ConsultationDestiantaireTextChanged,
    SiteNote_FollowUpChange,

    NotesClick,
    Note_Save,
    Note_Text_Changed,
    Note_Dropdown_Close,

    ActionNotesClick,
    ActionCheckBoxClick,
    ActionNote_Text_Changed,
    ActionNote_Save,
    ActioNote_Dropdown_Close,

    ActionDetails_Click,
    ActionDetails_Dropdown_Close,
    ActionDetails_CompleteAction,
    ActionDetails_DeleteAction,

    ClosePopups,

    Graphs_ShowGraphs,
    Graphs_BackToResults,
    Graphs_CheckboxChange,

    ResetView,

    ViewMounted,

    ShowClickableText,
    HideClickableText,

    PortalStatusClicked,
    PortalStatusCancel,
    PortalStatusRevoked,
    PortalStatusSend,
    PortalStatusSendAndHold,
    PortalStatusSendAndClassify,
    CloseSendToPortalPopup,
    OnPortalLabItemChecked,
    OnPortalLabItemToBeRevoke,
    LoadLabTaskStatus,
    ShowAttachedCommunicationsPopup,
    HideAttachedCommunicationsPopup,
    RedirectAndCloseAttachedCommunicationPopup,

    ShowExternalCommunicationPopup,
    ResultDetailClick,
    ToggleCreatePatientPopup,
    CreateNewPatientAndLinkResult,
    SideNote_LinkedAppointmentChange,
    Load_PatientAppointments,
    SetOntarioEnrollmentPatientBanner,
    OpenManualEntryFormPopup,
    CloseManualEntryFormPopup,

    FileManualLab
}

enum CommunicationsRecalls {
    Search_Show = 1500,
    Search_OnRefreshClick,
    Search_OnSettingsClick,
    Search_SearchTextChange,
    Search_DueDateFromChange,
    Search_DueDateToChange,
    Search_CheckboxChange,
    Search_ColumnOrderingPopupClick,
    Search_ColumnOrderingPopupClose,
    Search_OnSettingsCancelClick,
    Search_OnSettingsOkClick,
    Search_ResultsPerPageChange,
    Search_CliniciansSearchStringChange,
    Search_CurrentPageChange,
    Search_RowClick,

    Search_NoteLoad,
    Search_NoteSave,
    Search_NoteTextChanged,
    Search_NoteDropDownClosed,
    Search_Note_Window_Resize,
    Search_Note_StatusChanged,

    Note_AddNewNote,

    Create_Show,
    Create_CancelClick,
    Create_ClearClick,
    Create_CreateClick,
    Create_PatientSelect,
    Create_PatientClear,
    Create_DescriptionChange,
    Create_ClinicianSelect,
    Create_SpecialityChange,
    Create_DueDateSelect,
    Create_DueDateToday,
    Create_ShowClickableNotes,
    Create_PriorityChange,
    Create_NotesChange,
    Create_DescriptionSelect,
    Create_DescriptionClear,

    View_Show,
    View_StatusChange,
    View_NotesChange,
    View_SaveClick,
    View_SaveAndApproveClick,
    View_CancelClick,
    View_RecallNotesChange,
    View_CompleteRecall,
    View_ShowClinicianPopupMenu,

    Table_RecallRowClick,
    Checkbox_Change
}

enum Communications {
    Checkbox_Change = 1850,

    // todo cleanup this:
    Settings_FromDateChanged,
    Settings_ToDateChanged,
    Show_Create_Message,
    Show_Create_Task,
    Show_Create_Recall,
    UpdateCounters,
    Task_Show_VacationResponderPopup,
    Hide_VacationResponderPopup,
    Hide_EmptyGroupPopup,
    Task_Show_EmptyGroupPopup,
    Message_Show_EmptyGroupPopup,
    CommunicationStatesSave,
    SavePrefilledSelectedClinicians,
    SetCurrentSharedItemId,
    UpdatePortalCommunicationFetchedSharedItemsAndTotalCount,
    RemovePortalCommunicationFetchedSharedItems,
    UpdatePortalCommunicationFilterSetting,
    SavePortalCommunicationTableSetting
}

enum Settings {
    LanguageChange = 1900,
    UnitChange,
    ActiveSiteChange,
    DocumentViewChange,
    ChangePasswordClick,
    ChangePharmacotherapeuticAssistant,
    ChangeAutoIncludeDiagnoses,
    ChangeDefaultRefillNumber,
    SaveRefillNumber,
    SaveAutoResponder,
    ClearAutoResponder,
    ClearSignatureImage,
    LoadSharingConfiguration,
    UpdateSharingConfiguration,
    SharedTasksClinicianChange,
    SharedMessagesClinicianChange,
    ShareLabResults,
    ChangePrintingHeightWidth,
    ChangePageOrientation,
    ChangePrescriptionPrinter,
    ChangeAppointmentPrinter,
    ChangeTagSelection,
    SignatureUploadComplete,
    OrphanLabsClinicianChange,
    OrphanLabsFromChange,
    OrphanLabsToChange,
    AddClinicianToOrphanLabsList,
    RemoveClinicianFromOrphanLabsList,
    LoadOrphanLabsForwards,
    LoadSignatureImage,
    SavePreferedFaxNumber,
    ShowDiagnosisCode,
    RefreshSettings,
    LoadEmployeeEmails,
    SaveEmployeeEmails,
    VerifyEmployeeEmail,
    ResendEmployeeEmailVerificationCode,
    ActiveDepartmentChange,
    ChangeTelemedWindowOption,
    SharedExternalCommunicationClinicianChange,
    ShowAndCalculateMedicationDispensationQuantities,
    UpdateSignatureAndPinFrequency,
    UpdatePinFrequency,
    ChangeDefaultLongTermMedicationDuration,
    ChangeDefaultLongTermMedicationRefillNumber,
    UpdateAuthenticatorCodeDeliveryMethod,
    ChangeShouldAttachMedicalSummaryWhenCreatingConsultationRequest,
    ChangeShouldAttachMedicationSummaryWhenCreatingConsultationRequest,
    ChangeDrugInteractionAlertsFilterOption,
    SharedPortalCommunicationClinicianChange,
    UpdateAllowPatientsToInitiatePortalMessages,
    ChangeShowAlertsAndSpecialNeedsInPrintedSummary,
    ChangeShowPopupForNewAlertsAndSpecialNeeds
}

enum Calendar {
    Checkbox_Change = 2200,

    DisplaySettings_Ok,
    DisplaySettings_Cancel,
    DisplaySettings_ChangeTimeResolution,
    DisplaySettings_ChangeMaximumCalendarsShownForDay,
    DisplaySettings_ChangeMaximumCalendarsShownForWeek,
    DisplaySettings_ChangeMaximumCalendarsShownForMonth,
    DisplaySettings_EmployeeFilterChange,

    CalendarView_Day_Click,
    CalendarView_Week_Click,
    CalendarView_Month_Click,
    Calendar_Monthview_DayClick,
    Calendar_PAList_Mounted,
    Calendar_PAList_SearchChanged,
    CalendarPage_Previous_Click,
    CalendarPage_Next_Click,
    CalendarPage_PreviousDate_Click,
    CalendarPage_NextDate_Click,

    Ruleset_ClosePopup,
    Ruleset_SaveChanges,
    Ruleset_ChangeComboServiceSelection,
    Ruleset_OpenAddServicePopup,
    Ruleset_CloseAddServicePopup,
    Ruleset_StartOverBtnClick,
    Ruleset_AddServicePopup_AddBtn_Click,
    Ruleset_OpenRulesetCollisionPopup,
    Ruleset_CloseRulesetCollisionPopup,
    Ruleset_StartDateChanged,
    Ruleset_EndDateChanged,
    Ruleset_ShowMinErrorPopup,

    PAList_Table_UpdateColumnWidthPreferencesInStore,
    PAList_RowClick,
    PAList_Setting_Click,
    PAList_Setting_CancelClick,
    PAList_Setting_OkClick,
    PAList_SaveSettingsSelected,
    PAList_OnSettingsContainerCheckboxChange,
    PAList_SearchSettings_ClinicianFilterTextChanged,
    PAList_ColumnOrderingPopup_Close,
    PAList_ColumnOrderingPopup_Open,
    PAList_Search_TextBoxChanged,

    PAList_DisplaySettings_CloseColumOrderPopupClick,
    PAList_DisplaySettings_Load,
    PAList_DisplaySettings_MoveAvailableColumnRight,
    PAList_DisplaySettings_MoveDisplayedColumnDown,
    PAList_DisplaySettings_MoveDisplayedColumnLeft,
    PAList_DisplaySettings_MoveDisplayedColumnUp,
    PAList_DisplaySettings_Save,
    PAList_DisplaySettings_SelectAvailableColumn,
    PAList_DisplaySettings_SelectDisplayColumn,
    PAList_DisplaySettings_ShowColumOrderPopupClick,

    PAList_LabelPrint_CompleteOne,
    PAList_LabelPrint_Billing,

    Appointment_Show_Edit_Dialog,
    Appointment_NewAppointment_Dialog,
    Appointment_RemoveAppointment,
    Appointment_RemovePredefinedAppointment,
    Appointment_Show_Ruleset_Edit,

    AppointmentEdit_Patient_OnChange,
    AppointmentEdit_Patient_OnClear,
    AppointmentEdit_Patient_TextChange,

    AppointmentEdit_Subject_onClearSelectedService,
    AppointmentEdit_Subject_onServiceSelected,
    AppointmentEdit_Subject_OnChange,
    AppointmentEdit_Site_OnChange,
    AppointmentEdit_Room_OnChange,
    AppointmentEdit_State_OnChange,
    AppointmentEdit_Intervenors_OnChange,
    AppointmentEdit_StartDate_Set,
    AppointmentEdit_StartTime_Set,
    AppointmentEdit_EndTime_Set,
    AppointmentEdit_CanadianTriageAndAcuityScore_OnChange,
    AppointmentEdit_Tab_OnChange,

    AppointmentEdit_Recurrence_OnChange,
    AppointmentEdit_Recurrence_EndDate_Set,
    AppointmentEdit_Notes_OnChange,
    AppointmentEdit_Referrals_OnChange,
    AppointmentEdit_Referrals_OnClear,
    AppointmentEdit_Referrals_OnTextChange,
    AppointmentEdit_ReferralPhone_OnChange,
    AppointmentEdit_RecallsToggle,
    AppointmentEdit_OnCancel,
    AppointmentEdit_OnSave,
    AppointmentEdit_GroupConfirmSave,
    AppointmentEdit_OnSaveAndOpen,
    AppointmentEdit_OnCompleteRecall,
    AppointmentEdit_OnOpen,

    Appointment_Patient_Load,
    Appointment_Patient_Save,
    Appointment_Patient_Cancel,
    AppointmentEdit_Copy,
    AppointmentEdit_Cut,
    AppointmentEdit_Paste,
    AppointmentEdit_PrintLabel,
    AppointmentEdit_NewPatientClick,
    AppointmentEdit_NewPatient_Cancel,
    AppointmentEdit_NewPatient_Save,
    AppointmentEdit_LinkPatientPortalClick,
    AppointmentEdit_LinkPatientPortal_Cancel,
    AppointmentEdit_LinkPatientPortal_CreatedOrAttached,
    AppointmentEdit_LinkThirdPartyPatientClick,
    AppointmentEdit_LinkThirdPartyPatientSuccess,
    AppointmentEdit_LinkThirdPartyPatientCancel,
    AppointmentEdit_IsPaidCheck,
    AppointmentEdit_CancelPortalPatientFetch,
    AppointmentEdit_DoubleBooking_Cancel,
    AppointmentEdit_DoubleBooking_Continue,
    AppointmentEdit_Duplicate_AssociatePatient,
    AppointmentEdit_Questionnaire_OnChange,
    AppointmentEdit_Questionnaire_OnClick,
    AppointmentEdit_Questionnaire_OnSubmitted,
    AppointmentEdit_SetOntarioEnrollmentPatientBanner,
    AppointmentEdit_PrintCertificate,

    Calendar_Refresh_Click,
    Calendar_PA_Click,
    Calendar_MD_Click,
    Calendar_Print_Click,
    Calendar_Settings_Click,

    Calendar_PrintDialog_Cancel_Click,
    Calendar_PrintDialog_Print_Click,
    Calendar_PrintDialog_ClinicianPrintOptionChange,

    Calendar_PrintByDoctorDialog_Cancel_Click,
    Calendar_PrintByDoctorDialog_EraseAll_Click,
    Calendar_PrintByDoctorDialog_Print_Click,
    Calendar_PrintByDoctorDialog_EmployeeFilterChange,
    Calendar_PrintByDoctorDialog_ClinicianPrintOptionChange,
    OnScroll,

    Calendar_OnCloseAlreadyBookedAppointment,
    Calendar_DeleteMyleRuleset,
    AppointmentEdit_IsTeleconsultationCheck,

    RedirectToPatientFile,
    AppointmentEdit_IsContactPointNotificationChecked,
    AppointmentEdit_IsSendNotificationsToAllPersonalContactsChecked,
    ShowQuestionnaire,
    OnQuestionnaireSubmitted,
    ShowNoticeBoard
}

enum SettingsUI {
    ShowPwdChange = 3200,
    HidePwdChange,
    ShowPINChange,
    HidePINChange,
    CancelPwdChange,
    ShowUrlEditControl,
    HideUrlEditControl,
    ToggleEnrollmentSummary,
    AutoRespondersControlShowHide,
    AutoRespondersControlShow,
    ExportEnrollmentCSV,
    CloseLocateDSQKeysPopup,
    SelectDSQKey,
    ShowMultifactorAuthenticationPopup
}

enum Reporting {
    Store_Mounted = 3300
}

enum Portal {
    CreatePatientFromSyncPopup = 3400,
    Subscription_Create,
    Subscription_Load,
    UpdateProfileWithNewPortalStatus,
    Subscription_AddMyleAccount,
    Subscription_RemoveMyleAccount,
    Subscription_MakePayment,
    Subscription_CompletePayment,
    ClearBackendErrors,
    PortalManagement_Show,
    PortalManagment_LoadPortalProfileOverview,
    Account_Load,
    Portal_UpdateInfo,
    Portal_UpdateState,
    PaymentCustomer_Load,
    Portal_AddSharedItem,
    Portal_RevokeSharedItem
}

enum Portfolio {
    SwitchTo_NotesInbox = 3500,
    SwitchTo_RequestsInbox,
    SwitchTo_ConsultationRequestsInbox,
    SwitchTo_SentFaxInbox,
    SwitchTo_PendingApprovals,
    SwitchTo_APSS,
    SwitchTo_PortalPendingItems,
    SwitchTo_PortalSyncItems,
    SwitchTo_Extension,
    SwitchTo_PreventiveActivitiesInbox,
    SwitchTo_PortalPendingErrorItems,
    SwitchTo_PreventiveRecallList,

    PortfolioTab_didMount,
    PortfolioTab_willMount,

    MyNotes_Reload,
    MyNotes_SearchBoxTextChanged,
    MyNotes_SearchSettings_ShowOptionsButtonClick,
    MyNotes_OnSettingsContainerCheckboxChange,
    MyNotes_SearchSettings_FromDateChanged,
    MyNotes_SearchSettings_ToDateChanged,
    MyNotes_SearchSettings_ClinicianFilterTextChanged,
    MyNotes_SearchSettings_ColumnOrderingPopup_Open,
    MyNotes_SearchSettings_ColumnOrderingPopup_Close,
    MyNotes_SearchSettings_CancelClick,
    MyNotes_SearchSettings_OkClick,
    MyNotes_SearchSettings_OnResultsPerPageChange,
    MyNotes_Search_CurrentPageChange,
    MyNotes_OnPatientClick,
    MyNotes_UpdateEncountersData,
    MyNotes_Refresh_ClaimStatus,

    MyConsultationRequests_SearchBoxTextChanged,
    MyConsultationRequests_Reload,
    MyConsultationRequests_SearchSettings_ShowOptionsButtonClick,
    MyConsultationRequests_SearchSettings_ColumnOrderingPopup_Open,
    MyConsultationRequests_SearchSettings_ColumnOrderingPopup_Close,
    MyConsultationRequests_SearchSettings_CancelClick,
    MyConsultationRequests_SearchSettings_OkClick,
    MyConsultationRequests_SearchSettings_OnResultsPerPageChange,

    MyConsultationRequests_PrintSelectedConsultationRequest,
    MyConsultationRequests_PrintSelectedConsultationRequest_Signed,
    MyConsultationRequests_Search_CurrentPageChange,
    MyConsultationRequests_OpenSentFaxPopup,
    MyConsultationRequests_SendToPortal_IconClick,
    MyConsultationRequests_SendToPortal_RevokeClick,
    MyConsultationRequests_SendToPortal_CancelClick,
    MyConsultationRequests_SendToPortal_SyncClick,

    ConsultationRequest_CloseFaxPopup,
    ConsultationRequest_CloseFaxResponsePopup,
    ConsultationRequest_Fax,

    MyRequests_SearchBoxTextChanged,
    MyRequests_SearchSettings_ShowOptionsButtonClick,
    MyRequests_SearchSettings_ColumnOrderingPopup_Open,
    MyRequests_SearchSettings_ColumnOrderingPopup_Close,
    MyRequests_SearchSettings_CancelClick,
    MyRequests_SearchSettings_OkClick,
    MyRequests_SearchSettings_OnResultsPerPageChange,
    MyRequests_OpenRequestPopup,
    MyRequests_CloseRequestPopup,
    MyRequests_LoadPatientInfo,
    MyRequests_DeleteSelectedRequest,
    MyRequests_PrintSelectedRequest,
    MyRequests_Search_CurrentPageChange,
    MyRequests_CloseRequestLabFaxResponsePopup,

    MySentFaxes_OpenFaxPreview,
    MySentFaxes_SearchBoxTextChanged,
    MySentFaxes_SearchSettings_ShowOptionsButtonClick,
    MySentFaxes_OnSettingsContainerCheckboxChange,
    MySentFaxes_SearchSettings_FromDateChanged,
    MySentFaxes_SearchSettings_ToDateChanged,
    MySentFaxes_SearchSettings_ClinicianFilterTextChanged,
    MySentFaxes_SearchSettings_ColumnOrderingPopup_Open,
    MySentFaxes_SearchSettings_ColumnOrderingPopup_Close,
    MySentFaxes_SearchSettings_CancelClick,
    MySentFaxes_SearchSettings_OkClick,
    MySentFaxes_SearchSettings_OnResultsPerPageChange,
    MySentFaxes_OpenSentFaxPopup,
    MySentFaxes_CloseSentFaxPopup,
    MySentFaxes_LoadPatientInfo,
    MySentFaxes_Search_CurrentPageChange,
    MySentFaxes_ResendFax,
    MySentFaxes_ToggleFailedVisibility,

    PendingApproval_OnSettingsContainerCheckboxChange,
    PendingApproval_SearchSettings_FromDateChanged,
    PendingApproval_SearchSettings_ToDateChanged,
    PendingApproval_SearchSettings_ShowOptionsButtonClick,
    PendingApproval_SearchSettings_CancelClick,
    PendingApproval_SearchSettings_OkClick,
    PendingApproval_SearchSettings_ColumnOrderingPopup_Open,
    PendingApproval_SearchSettings_ColumnOrderingPopup_Close,
    PendingApproval_SearchSettings_ClinicianFilterTextChanged,
    PendingApproval_Reload,
    PendingApproval_SearchTextChanged,
    PendingApproval_OnEncounterClick,
    PendingApproval_OnModifyEncounterClick,
    PendingApproval_OnNotesPopupOpen,
    PendingApproval_SelectResidentSupervisor,
    PendingApproval_ClearSelectedSupervisor,
    PendingApproval_OnResidentMessageChange,
    PendingApproval_OnSendClick,
    PendingApproval_CloseApprovalSupervisorPopup,
    PendingApproval_OnApprovePendingApprovalClick,
    PendingApproval_OnReturnPendingApprovalClick,
    PendingApproval_OnReturnPendingApprovalMessageChange,
    PendingApproval_OnReturnPopupClick,
    PendingApproval_OnApprovePopupClick,
    PendingApproval_SetSelectedEncounterInfo,

    APSS_Reload,
    APSS_ToggleOpenCloseSettings,
    APSS_HideSettings,
    APSS_UpdateApssCount,
    APSS_SearchSettings_ShowColumnOrdering,
    APSS_SearchSettings_HideColumnOrdering,
    APSS_SearchChange,
    APSS_RowClick,
    APSS_PageEvent,
    APSS_OnSettingsContainerPerPageChange,
    APSS_OnShowOnlyMissingRequierementChange,
    APSS_OnShowArchivedPurgesChange,
    APSS_ExpandTableItem,
    APSS_ConseilNumerique_Reload,
    APSS_ConseilNumerique_SearchChange,
    APSS_ConseilNumerique_PageEvent,
    APSS_OnShowArchivedConseilNumerique,
    APSS_SearchSettings_ChangeEmployee,

    LabRequest_CloseSignFaxPopup,
    LabRequest_OpenSignFaxPopup,

    PortalSync_Reload,
    PortalSync_CurrentPageChanged,
    PortalSync_SearchBoxTextChanged,
    PortalSync_SearchSettings_Open,
    PortalSync_SearchSettings_CancelClick,
    PortalSync_SearchSettings_OkClick,
    PortalSync_ColumnOrder_PopupOpen,
    PortalSync_ColumnOrder_PopupClose,
    PortalSync_Column_SortClick,
    PortalSync_RowClick,
    PortalSync_PatientClick,
    PortalSync_SendToPortal_MessageChecked,
    PortalSync_SendToPortal_RevokeClick,
    PortalSync_SendToPortal_SyncClick,
    PortalSync_SendToPortal_CancelClick,

    LabRequest_CloseFaxResponsePopup,
    LabRequest_Fax,
    RequestPopup_OnSave,
    ConsultationRequestPopup_OnSave,
    MyRequests_OnPatientClick,
    MyConsultations_OnPatientClick,
    TogglePDFSideBar,
    SwitchTo_FailedFaxes,

    PreventiveActivitiesInbox_LoadSettingsSearch,
    PreventiveActivitiesInbox_SettingsContainerVisibility,
    PreventiveActivitiesInbox_LoadFromSearch,
    PreventiveActivitiesInbox_ColumnOrderingPopupVisibility,
    PreventiveActivitiesInbox_SetPage,

    PreventiveRecallList_Reload,
    PreventiveRecallList_SearchSettings_Container_Visibility,
    PreventiveRecallList_SearchSettings_ColumnOrderingPopup_Visibility,
    PreventiveRecallList_PreventiveCareCriteria_Visibility,
    PreventiveRecallList_SearchSettings_Load,
    PreventiveRecallList_Load_From_Search,
    PreventiveRecallList_NavigateBetweenTabs,
    PreventiveRecallList_SelectItem,
    PreventiveRecallList_SelectAllItems,
    PreventiveRecallList_SetPage,
    PreventiveRecallList_LoadPreventiveCareCriteria,
    PreventiveRecallList_OnGenerateLettersClick,
    PreventiveRecallList_UpdateLastCommunicationDate,
    PreventiveRecallList_OnGenerateBonusReportClick,
    PreventiveRecallList_GenerateBonusReport_Visibility,
    PreventiveRecallList_InterruptGenerateBonusReportLoading,
    PreventiveRecallList_LoadPreventiveCareNotices,

    SwitchTo_PopulationBasedFunding,
    PopulationBasedFunding_LoadEvents,
    ResetCache
}

enum Billing {
    Store_Mounted = 4200,

    SwitchTo_TransactionsInbox,
    SwitchTo_SalesInbox,
    SwitchTo_PayableInbox,
    Generate_BillingCSV,

    Transactions_SearchBoxTextChanged,
    Transactions_SearchSettings_ShowOptionsButtonClick,
    Transactions_OnSettingsContainerCheckboxChange,
    Transactions_SearchSettings_FromDateChanged,
    Transactions_SearchSettings_ToDateChanged,
    Transactions_SearchSettings_ProviderFilterTextChanged,
    Transactions_SearchSettings_BilledByFilterTextChanged,
    Transactions_Search_CurrentPageChange,
    Transactions_SearchSettings_OnResultsPerPageChange,
    Transactions_SearchSettings_ColumnOrderingPopup_Open,
    Transactions_SearchSettings_ColumnOrderingPopup_Close,
    Transactions_SearchSettings_CancelClick,
    Transactions_SearchSettings_OkClick,
    Transactions_Refresh_ButtonClick,
    Transactions_Open_BillingPopup,
    Transactions_Close_BillingPopup,
    Transactions_PrintReport,
    Transactions_SearchSettings_VisitFromDateChanged,
    Transactions_SearchSettings_VisitToDateChanged,
    Transactions_SearchSettings_PaymentDateFromChanged,
    Transactions_SearchSettings_PaymentDateToChanged,
    Transactions_SearchSettings_UpdatePayablePaymentMethodName,

    Sales_SearchBoxTextChanged,
    Sales_SearchSettings_ShowOptionsButtonClick,
    Sales_OnSettingsContainerCheckboxChange,
    Sales_SearchSettings_FromDateChanged,
    Sales_SearchSettings_ToDateChanged,
    Sales_SearchSettings_ProviderFilterTextChanged,
    Sales_SearchSettings_BilledByFilterTextChanged,
    Sales_Search_CurrentPageChange,
    Sales_SearchSettings_OnResultsPerPageChange,
    Sales_SearchSettings_ColumnOrderingPopup_Open,
    Sales_SearchSettings_ColumnOrderingPopup_Close,
    Sales_SearchSettings_CancelClick,
    Sales_SearchSettings_OkClick,
    Sales_Refresh_ButtonClick,
    Sales_PrintReport,
    Sales_SearchSettings_VisitFromDateChanged,
    Sales_SearchSettings_VisitToDateChanged,

    Payable_LoadPaybleInboxItems,
    Payable_PrintReport,
    BillingClaimStatusCount,
    BillingClaimStatusInbox,

    ClaimStatus_SearchSettings_FromDateChanged,
    ClaimStatus_SearchSettings_ToDateChanged,
    ClaimStatus_SearchSettings_SelectAllSites,
    ClaimStatus_SearchSettings_SelectSite,
    ClaimStatus_SearchSettings_SelectProvider,
    ClaimStatus_SearchSettings_SelectedProvidersChanged,
    ClaimStatus_SearchSettings_SelectInvoiceStatus,
    ClaimStatus_SearchSettings_SelectedInvoiceStatusesChanged,
    ClaimStatus_SearchSettings_IsIgnoredChanged,
    ClaimStatus_SearchSettings_ProviderFilterTextChanged,
    ClaimStatus_SearchSettings_QueryPageSizeChanged
}

enum Lists {
    Show_Create_List = 4500,
    SearchSettings_SearchBoxTextChanged,
    DeleteLists,
    List_AddAPatient,
    Store_Mounted,
    OnListTreeTitleClick,
    List_Selected,

    AddNewList_Popup_Ok,
    AddNewList_Popup_Cancel,
    AddNewList_ShowPopup,

    OnRefreshButtonClick,
    OnSettingsButtonClick,
    SearchBoxTextChanged,

    SearchSettings_ColumnOrderingPopup_Open,
    SearchSettings_CancelClick,
    SearchSettings_OkClick,
    SearchSettings_OnResultsPerPageChange,
    SearchText_Change,

    List_EditName,
    EditListName_Popup_Ok,
    EditListName_Popup_Cancel,
    EditListName_ShowPopup,
    EditItem_ValidatePriorityValue,

    DeleteListItem_ShowPopup,
    DeleteListItem_Popup_Cancel,
    DeleteListItem_Popup_Ok,

    DeleteList_ShowPopup,
    DeleteList_Popup_Cancel,
    DeleteList_Popup_Ok,

    Search_CurrentPageChange,
    SearchSettings_ColumnOrderingPopup_Close,
    OpenEditListItemPopup,

    OnAddAPatientClick,
    SelectPatientToAdd,
    CloseSelectedPatientPopup,
    CloseSearchPatientPopup,
    SavePatientForList,

    OnRowClick,
    EditItem_Popup_Ok,
    EditItem_Popup_Cancel,
    EditItem_PriorityValueChanged,
    EditItem_CommentsValueChanged,

    OnPrintButtonClick,
    ToggleListsSearchSideBar
}

enum AdministrationTab {
    SubTabSwitch = 50000
}

enum AdministrationServiceCombo {
    SubTabSwitch = 50050,

    RefreshGrid,
    SaveDisplaySettings,
    CreateCombo_Click,
    CreateService_Click,
    SaveService_Click,
    SaveCombo_Click,
    SearchSettings_Open,
    SearchSettings_Close,
    SearchSettings_OK,
    SearchSettings_CheckChanged,
    SearchSettings_SearchTextChanged,
    SearchSettings_EmployeeFilterTextChanged,
    ServiceDefinitionEdit_Open,
    ServiceDefinitionEdit_Close,
    ServiceDefinitionPortalDetailsEdit_Open,
    ServiceDefinitionPortalDetailsEdit_Close,
    ExportService_Open,
    ExportService_Close,
    NotificationConfiguration_Open,
    NotificationConfiguration_Close
}

enum SchedulingTab {
    SubTabSwitch = 51000
}

enum OpenScheduleTab {
    ChangeComboServiceSelection = 51100,
    SelectExistingRuleset,
    SaveRulesetChanges,
    CancelRulesetChanges,
    ClearRulesetInfo

}

enum TemplateTab {
    LoadLightTemplate = 51200,
    LoadTemplateInfo,
    DeleteTemplate,
    SearchText,
    NewTemplateClick,
    ModifyClick,
    OpenIntervenorPopup,
    ModifyRuleSetClick,
    OpenDeletePopup
}

enum CreateTemplateTab {
    CancelClick = 51300,
    OnNameChange,
    OnHourStartChange,
    OnHourEndChange,
    OnSiteChange,
    AddPredefinedTemplate,
    SavePredefinedTemplate,
    SaveEditionPredefinedTemplate,
    ChangeTypeCode,
    OpenAddServicePopup,
    ChangeComboServiceSelection,
    AddRuleSetService,
    PrepareRuleSetSave,
    SaveRuleSetTemplate,
    OnDeleteClick,
    OnDeleteRuleSetClick,
    ClearModel,
    DeleteItemFromNewTemplate,
    ClearCurrentRulesetInfo,
    UpdateSelectedComboServicesOnChanges,
    StartOver,
    SelectExistingRuleset
}

enum Misc {
    MyleApp_Container_Click = 51400,
    RedirectToTab,
    ClickableTextControlAppend = 51405,
    ToggleMyleSchedulerDisplayMode,
    UpdateRAMQInfoInPatient,
    RAMQInfoInPatientReceived,
    Focus,
    SearchMedicationBlurReset,
    ReloadPatientSummaryAndGoToEncounter,
    FileUploader_Send,
    FilePreview_ExternalClick,
    Table_ColumnSortClick,
    ExternallyCalled_SavePatientAppointmentSearch,
    ReloadEmployeesAndService,
    ReloadLookups,
    FileUploader_Update,
    UpdateNotesFilterSettings,
    UpdateSummaryConfigurationSettings
}

enum MainComponentViewOperations {
    DisplayCreateClickableText = 51500,
    DisplaySyncModal,
    HideSyncModal,
    RefreshTabs,
    DisplayExternalSearch,
    DisplayApexExternalSearchPopup,
    EditorClosed,
    DisplayDSQPopup,
    DisplayDSQActiveMedPopup,
    DisplayDSQLabsGridPopup,
    DisplayDSQImgsGridPopup,
    DisplayDSQNip,
    DisplayDSQEmployeePopup,
    DisplayCommonPopup,
    HideCommonPopup,
    DisplaySessionWarningPopup,
    DisplayAttachmentPopup,
    DisplayOpenAttachmentPopup,
    RefreshCounters,
    ShowVisitTypeSelectionPopup,
    DisplayFacturationNetUsernamePasswordPopup,
    FaxPrintExportableFile,
    ChangeTelemedPopupUrl,
    DisplayExternalBillingAuthentication,
    DisplayExternalBillingEmployeeSelect,
    DisplayPatientWarnings,
    DisplayAdditionalSignOffInformationPopup,
    DisplaySignatureOptionPopup,
    DisplayTermsAndConditionsPopup
}

enum AdministrationBillableService {
    GetAllBillableService = 51900,
    RefreshGrid,
    SearchSettings_SearchTextChanged,
    SearchSettings_Open,
    SearchSettings_Close,
    BillableService_OnSettingsContainerCheckboxChange,
    BillableService_SearchSettings_OkClick,
    BillableServiceEdit_Close,
    BillableServiceEdit_Open,
    BillableServiceEdit_Save,
    OpenCreateNewBillableService,
    BillableService_CurrentPageChange,
    BillableService_SearchSettings_OnResultsPerPageChange,
    SearchSettings_ColumnOrderingPopup_Open
}

enum AdministrationUsers {
    ToggleUserSearchSideBar = 52500,
    GetAllEmployeeSearch,
    HideInactiveUsers,
    InActivateUsers,
    SubmenuClick,
    ReinitUsersPopupOpen,
    ReinitUsersPopupClose,
    GetEmployeeInfo,
    GetEmployeeSelectedInfo,
    ChangePageOrientation,
    ChangePrintingHeightWidth,
    ChangePrescriptionPrinter,
    ChangeAppointmentPrinter,
    ProfilePictureUploaded,
    ProfilePictureDeleted,
    ShowCreateEmployeePopup,
    CloseCreateEmployeePopup,
    CreateClinicalEmployee,
    CreateClericalEmployee,
    EditUser,
    CancelEditUser,
    EditUserNextSection,
    EditUserPreviousSection,
    SaveUser,
    OrphanLabsClinicianChange,
    OrphanLabsFromChange,
    OrphanLabsToChange,
    AddClinicianToOrphanLabsList,
    RemoveClinicianFromOrphanLabsList,
    ChangeTagSelection,
    AddNewUsefulLink,
    ShowNotePopup,
    OpenAddServiceCombo,
    AddUserServiceComboPopupClose,
    SearchSettings_Open,
    SearchSettings_Close,
    SaveNewServicesCombo,
    CloseRefreshClickableText,
    OpenModifyUserTypePopup,
    PhoneModify,
    EmailModify,
    UserNameModify,
    PasswordModify,
    CloseModifyUserTypePopup,
    UserTypeModify,
    ShowLoadClickableTextFromAnotherUsers,
    LoadClickableTextFromAnotherUser,
    IsCreateClickableTextOpen,
    MutateEmployeeUIModel,
    RefreshServices,
    PinModify,
    CloseModifyPinPopup,
    SavePinModify,
    setTextSearch,
    DeleteClickableTextSection,
    OpenImportClickableText,
    CloseClickableTextImport,
    SaveClickableTextImport,
    AddClickableTextImport,
    SetActivatedTabImportClickabeText,
    SelectDetailsOfClickableText,
    GetAllClickableTectFromSpecificUserForSpecificContext,
    SelectClickableTextFromSpecificUserSpecificTab,
    CleanDetailsOfClickableText,
    AddGroupSettingToUser,
    OnChangeLanguageForClickableText,
    ResendEmailVerificationCode
}

enum AdministrationGroup {
    GetAllGroupSearch = 52700,
    ToggleGroupSearchSideBar,
    OpenCreateNewGroupPopup,
    CloseCreateNewGroupPopup,
    IsEditGroupDetailsSetting,
    GetGroupInfo,
    OpenAddServiceCombo,
    MutateGroupModel,
    SaveGroup,
    CancelEditGroup,
    ModifyGroup,
    ChangeTagSelection,
    AddNewUsefulLink,
    RefreshServices,
    AddUserServiceComboPopupClose,
    SaveNewServicesCombo,
    SearchSettings_Close,
    SearchSettings_Open,
    OnChangeGroupName,
    SetTextSearch,
    OpenImportClickableText,
    CloseRefreshClickableText,
    DeleteClickableTextSection,
    GetAllClickableTectFromSpecificGroupForSpecificContext,
    CloseClickableTextImport,
    SelectDetailsOfClickableText,
    SetActivatedTabImportClickabeText,
    CleanDetailsOfClickableText,
    SaveClickableTextImport,
    SaveAndApplyGroup,
    LoadClickableTextFromAnotherUser,
    // ShowLoadClickableTextFromAnotherUsers,
    IsRenameGroupPopupOpen,
    RenameGroupName,
    OnChangeLanguageForClickableText
}

enum Sites {
    LoadSites = 52900,
    OpenSelectedSite,
    AddNewSite,
    SaveSite,
    ModifySite,
    CancelSite,
    AddOrganization,
    CloseDuplicatePopup,
    ProceedClick,
    SaveLogo,
    SetActiveSite
}

enum AdministrationLog {
    GetAllLog = 53100,
    RefreshGrid,
    SearchSettings_SearchTextChanged,
    SearchSettings_UserFilterTextChanged,
    SearchSettings_ActionFilterTextChanged,
    SearchSettings_Open,
    SearchSettings_Close,
    SearchSettings_FromDateChanged,
    SearchSettings_ToDateChanged,
    SearchSettings_ContainerCheckboxChange,
    SearchSettings_OkClick,
    SearchSettings_NbAccessTextChanged,
    SearchSettings_IntervalTextChanged,
    SearchSettings_IntervalTypeChanged,
    CurrentPageChange,
    SearchSettings_OnResultsPerPageChange,
    SearchSettings_ColumnOrderingPopup_Open,
    LogPreview_Open,
    OntarioCdsExport_Open,
    OntarioCdsExport_Close,
    OntarioCdsImport_Open,
    OntarioCdsImport_Close
}

enum Relative {
    OpenFile = 53400,
    EditProfile,
    CancelProfileEdition,
    SaveProfileState,
    SwitchProfileTab,
    CloseFile,
    MarkAsReadProfileMemo
}

enum Person {
    LoadFile = 53500,
    OpenFile,
    CloseFile
}

enum PrescriptionRenewal {
    SetPrescriptionRenewalModel = 53600,
    SetPrescriptionRenewalInboxSettings,
    SetPrescriptionRenewalCachedModel,
    SetPrescriptionRenewalHistoryFilterSetting,
    ClearPrescriptionRenewalCache,
    SavePrescriptionRenewalsViewTogglerSession
}

enum AdministrationXComLogs {
    SearchSettings_SearchTextChanged = 53700,
    SearchSettingsApplied,
    OnPageChange
}

enum PharmacyOrders {
    SetPharmacyOrdersIds = 53800,
    SetIFilterSettings,
    SetTableSettings,
    SetCurrentPharmacyOrderId,
    SetAllergiesAndReactionsTogglerView
}

enum AIScribe {
    ShowAIScribePopup = 53900,
    CloseAIScribePopup,
    ShowAIScribeSubscriptionExpiredPopup,
    CloseAIScribeSubscriptionExpiredPopup,
    ShowAIScribeLinkPopup,
    CloseAIScribeLinkPopup,
    ShowAIScribeWarningActiveAssistant,
    CloseAIScribeWarningActiveAssistant,
    ShowAIScribeMarketingPopup,
    CloseAIScribeMarketingPopup,
    RemindMeLaterAIScribeMarketingPopup,
    CloseAIScribeUnlinkCarewayPopup,
    ShowAIScribeUnlinkCarewayPopup
}

export { AdministrationBillableService, AdministrationGroup, AdministrationLog, AdministrationServiceCombo, AdministrationTab, AdministrationUsers, AdministrationXComLogs, AIScribe, Billing, Calendar, Communications, CommunicationsRecalls, CreateTemplateTab, Documents, HandNote, Labs, LabsUI, Lists, Login, MainComponentViewOperations, Misc, OpenScheduleTab, Person, PharmacyOrders, Portal, Portfolio, PrescriptionRenewal, Relative, Reporting, Router, SchedulingTab, SendRecallPopup, SendTaskOrMessageModel, Settings, SettingsUI, Sidebar, Sites, TabLoadEvents, TemplateTab, Unassigned };
